import React from 'react'
import SearchBar from './SearchBar'
import youtube from '../apis/youtube'
import VideoList from './VideoList'
import VideoDetail from './VideoDetail'

const KEY = 'AIzaSyCdXwR9iztGthZGzca5k2Rq__iyX-bfThQ'

class App extends React.Component{

    state = { videos: [], selectedVideo: null }

    componentDidMount(){
        this.onTermSubmit('buildings');
    }
    
    onTermSubmit = async term =>{
        //console.log(term)
        const response = await youtube.get("/search", {
            params: {
                q: term,
                part: "snippet",
                type: 'video',
                maxResults: 10,
                key: `${KEY}`
            }
        })

        //console.log(response)
        this.setState({ 
            videos: response.data.items,
            selectedVideo: response.data.items[0]
        })
    }

    onVideoSelect = video => {
        //console.log('From the App!', video)
        this.setState({ selectedVideo: video })
    }

    render(){
        return (
            <div className="ui container">
                <h1 style={h1Style}>WeTube</h1>
                <SearchBar onSubmit={this.onTermSubmit} />
                Found {this.state.videos.length} videos.
                <div className="ui grid">
                    <div className="ui row">
                        <div className="eleven wide column">
                            <VideoDetail video={this.state.selectedVideo} />
                        </div>
                        <div className="five wide column">
                            <VideoList  onVideoSelect={this.onVideoSelect} 
                                        videos={this.state.videos} />
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

var h1Style = {
    color: 'blue',
    fontSize: '15 px',
    textAlign: 'center'
}
export default App;